import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { inr } from "@/api";
import { Reveal, MaskedLines, Overline } from "@/components/Motion";
import { usePage } from "@/settings";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("All");
  const pg = usePage("shop");

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  const cats = ["All", ...new Set(products.map((p) => p.category))];
  const list = cat === "All" ? products : products.filter((p) => p.category === cat);

  return (
    <main data-testid="shop-page" className="pt-32 pb-24 px-6 md:px-12 max-w-7xl mx-auto min-h-screen">
      <Overline>IKSHA Shop</Overline>
      <MaskedLines
        className="mt-6 mb-4"
        lineClassName="font-display text-5xl sm:text-6xl lg:text-8xl tracking-tight"
        lines={[pg.heading_1 || "The shop"]}
      />
      <Reveal>
        <p className="text-ink/60 max-w-xl mb-10">
          {pg.intro || "Originals, prints and handmade objects from the studio — each piece made or chosen with intent."}
        </p>
        <div className="flex flex-wrap gap-2 mb-14" data-testid="shop-category-filters">
          {cats.map((c) => (
            <button key={c} data-testid={`shop-filter-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              onClick={() => setCat(c)}
              className={`px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] border transition-colors duration-300 ${
                cat === c ? "bg-ink text-paper border-ink" : "border-ink/20 text-ink/60 hover:border-brand hover:text-brand"
              }`}>
              {c}
            </button>
          ))}
        </div>
      </Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14">
        {list.map((p, i) => (
          <Reveal key={p.id} delay={(i % 3) * 0.08}>
            <Link to={`/shop/${p.id}`} data-testid={`shop-product-${p.id}`} className="group block">
              <div className="frame-clip spotlight aspect-[4/5] bg-linen border border-ink/10 p-5 relative">
                <img src={p.images?.[0]} alt={p.name} className="w-full h-full object-cover" loading="lazy" />
                {p.status !== "Available" && (
                  <span className={`absolute top-4 left-4 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] ${
                    p.status === "Sold Out" ? "bg-ink text-paper" : "bg-brand text-paper"
                  }`}>
                    {p.status}
                  </span>
                )}
              </div>
              <div className="mt-4 flex justify-between items-baseline gap-3 border-t border-ink/15 pt-3">
                <h2 className="font-display text-xl group-hover:text-brand transition-colors leading-snug">{p.name}</h2>
                <span className="font-mono text-sm text-ink/70 shrink-0">{inr(p.price)}</span>
              </div>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink/40 mt-1">
                {p.category} · {p.dimensions}
              </p>
            </Link>
          </Reveal>
        ))}
      </div>
    </main>
  );
}
